import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Wallet, Users, TrendingDown, CreditCard } from "lucide-react";
import ExpenseTracking from "@/components/finance/ExpenseTracking";
import SupplierManagement from "@/components/finance/SupplierManagement";
import ClientCredit from "@/components/finance/ClientCredit";

const FinanceManagement: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("expenses");

  const tabs = [
    { id: "expenses", label: t("finance.expenses"), icon: TrendingDown, component: ExpenseTracking },
    { id: "suppliers", label: t("finance.suppliers"), icon: Users, component: SupplierManagement },
    { id: "clients", label: t("finance.clientCredit"), icon: CreditCard, component: ClientCredit },
  ];

  return (
    <div className="container mx-auto px-4 py-6 max-w-7xl">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
          <Wallet className="h-6 w-6 text-green-600 dark:text-green-400" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">{t("finance.title")}</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            {t("finance.expenses")}, {t("finance.suppliers")}, {t("finance.clientCredit")}
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3 mb-6">
          {tabs.map((tab) => {
            const IconComponent = tab.icon;
            return (
              <TabsTrigger key={tab.id} value={tab.id} className="flex gap-2">
                <IconComponent className="h-4 w-4" />
                <span>{tab.label}</span>
              </TabsTrigger>
            );
          })}
        </TabsList>

        {tabs.map((tab) => {
          const ComponentToRender = tab.component;
          return (
            <TabsContent key={tab.id} value={tab.id}>
              <ComponentToRender />
            </TabsContent>
          );
        })}
      </Tabs>
    </div>
  );
};

export default FinanceManagement;
